import { reduxForm, reset } from 'redux-form'
import moment from 'moment'

import CommentForm from '../../components/comments/comment-form'

import { createCommentForArea } from '../../actions/comments'
import { loadActivitiesForArea } from '../../actions/area-activities'

const fields = [
  'body',
  'timezone'
]

function mapDispatchToProps (dispatch, ownProps) {
  return {
    onSubmit (data) {
      dispatch(createCommentForArea(ownProps.areaId, data))
        .then(() => dispatch(loadActivitiesForArea(ownProps.areaId, false, true)))
        .then(() => dispatch(reset('createAreaComment')))
    }
  }
}

export default reduxForm(
  {
    fields,
    initialValues: {
      timezone: moment.tz.guess()
    },
    form: 'createAreaComment'
  },
  undefined,
  mapDispatchToProps
)(CommentForm)



// WEBPACK FOOTER //
// ./src/containers/comments/create-area-comment-container.js